<template>
  <div>
    <app-description></app-description>
    <div class="loader"></div>
    <SkeletonContainer v-if="!dataLoaded" :loadSkeletons="dataLoaded" />
    <div class="cards" v-else>
      <app-card
        v-for="(coin, index) in this.$store.getters.getCoins.Data"
        :key="index"
        v-bind:full_name="coin.CoinInfo.FullName"
        v-bind:name="coin.CoinInfo.Name"
        v-bind:symbol="getCoinImage(coin.CoinInfo.ImageUrl)"
        v-bind:rank="index + 1"
        v-bind:percent_change_1h="coin.percent_change_1h"
        v-bind:percent_change_7d="coin.percent_change_7d"
        v-bind:currency="currency"
        v-bind:raw="coin.RAW"
        v-bind:display="coin.DISPLAY"
      ></app-card>
    </div>
    <h3>Latest Crypto News</h3>
    <div class="cards" v-if="news.Data">
      <app-news
        v-for="(news, index) in news.Data.slice(0, 8)"
        :key="index"
        v-bind:url="news.url"
        v-bind:imageurl="news.imageurl"
        v-bind:title="news.title"
        v-bind:published_on="news.published_on"
      ></app-news>
    </div>
  </div>
</template>

<script>
const CRYPTOCOMPARE_API_URI = 'https://min-api.cryptocompare.com'
const CRYPTOCOMPARE_BASE_URI = 'https://www.cryptocompare.com'

const UPDATE_INTERVAL = 30 * 1000 //Change to 30 seconds

import Description from '@/components/Description'
import Dropdown from '@/components/Dropdown'
import Currency from '@/components/Currency'

import Card from '@/components/Card'
import News from '@/components/News'

import SkeletonContainer from '@/components/SkeletonCardContainer'

export default {
  name: 'cards',
  components: {
    'app-description': Description,
    'app-dropdown': Dropdown,
    'app-currency': Currency,
    'app-card': Card,
    'app-news': News,
    SkeletonContainer: SkeletonContainer,
  },
  data: function() {
    return {
      coins: [],
      coinData: {},
      dataLoaded: false,
      isOpen: false,
      currency: 'USD',
      apikey: process.env.API_KEY,
      news: [],
      charts: [],
      chartData: [],
      extraParams: '&extraParams=Watchcrypto',
    }
  },
  props: {
    skeletons: {
      default: 10,
    },
    lines: {
      default: 1,
    },
    stats: {
      default: 3,
    },
  },
  methods: {
    getNews: async function() {
      try {
        const url = `${CRYPTOCOMPARE_API_URI}/data/v2/news/?lang=EN${this.extraParams}&apikey${this.apikey}`
        await this.axios.get(url).then((res) => {
          this.news = res.data
        })
      } catch (err) {
        console.error(err)
      }
    },
    getColor: (num) => {
      return num > 0
        ? 'color:hsl(141, 71%, 48%);'
        : 'color:hsl(348, 100%, 61%);'
    },
    roundDec: (amount) => {
      if (amount) {
        return Math.round(amount * 100) / 100
      }
    },
    getCoinImage: function(symbol) {
      return CRYPTOCOMPARE_BASE_URI + symbol
    },
    currencyString: (currency) => {
      if (currency) {
        return '&tsym=' + currency
      } else {
        return '&tsym='
      }
    },
    getCoins: async function() {
      try {
        const url = `${CRYPTOCOMPARE_API_URI}/data/top/totalvolfull?limit=10${this.currencyString(
          this.currency
        )}&apikey=${this.apikey}`
        await this.axios.get(url).then((res) => {
          this.coins = res.data
          this.$store.commit('UPDATE_TOP_10_COINS', res.data)

          this.dataLoaded = true
          this.getNews()

          // Only pull data for one day charts once
          if (this.$store.getters.charts.length === 0) {
            this.getChartData()
          }
        })
        await nextTick()
      } catch (err) {
        console.error(err)
      }
    },
    getChartData: async function() {
      try {
        let charts = []

        //Get top 10 coins
        this.$store.getters.getCoins.Data.forEach(async (coin) => {
          const url = `${CRYPTOCOMPARE_API_URI}/data/v2/histoday?fsym=${coin.CoinInfo.Name}&tsym=USD&limit=11${this.extraParams}&apikey=${this.apikey}`
          await this.axios.get(url).then((res) => {
            charts.push({
              id: coin.CoinInfo.Name,
              data: res.data,
            })
          })
        })

        this.$store.commit('UPDATE_CHART', charts)
      } catch (err) {
        console.error(err)
      }
    },
  },
  created: function() {
    this.getCoins()
    setInterval(
      function() {
        this.getCoins()
      }.bind(this),
      UPDATE_INTERVAL
    )
  },
  watch: {
    currency: function() {
      this.getCoins()
    },
  },
  computed: {
    watchCurrency: function() {
      return 'coin.RAW.' + this.currency
    },
  },
}
</script>

<style lang="scss">
#svg-wavy {
  position: absolute;
}

.cards,
.chartWrapper {
  display: grid;
  max-width: 1200px;
  grid-gap: 12px;
  margin: 0 auto;
  padding: 0;
  grid-template-columns: repeat(auto-fill, minmax(282px, 1fr));
  // grid-auto-rows: 150px;
}

.p-mobile-only {
  display: none;
  margin: 0;

  @media (max-width: 480px) {
    display: inline;
  }
}

.p-desktop-only {
  display: none;
  margin: 0;

  @media (min-width: 481px) {
    display: inline;
  }
}

.toast {
  width: 492px;
  height: 30px; //40px
  margin: 0 auto;

  padding: 16px;
  border-radius: 4px;

  background: #ffffff;
  color: #b5b5b5;
  position: relative;
  box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.25);

  p {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue